import React from "react";
import PropTypes from "prop-types";
import ReactHtmlParser from "react-html-parser";
import { translate, getBlackAsterisk } from "application/functions";
import { isNil, isEmpty, contains } from "ramda";

const TextField = (props) => {
  const {
    errors,
    register,
    locale,
    field,
    regex,
    required,
    isSubmitted,
    label,
  } = props;

  const fieldRequired = translate("field.required", locale);

  const getErrorMessage = () => {
    const valueInput =
      errors[field] && errors[field].ref ? errors[field].ref.value : "";
    let errorMessage = "";
    if (!isEmpty(valueInput)) {
      const key = `field.required.${field}`;
      errorMessage = translate(key, locale);
    } else {
      errorMessage = translate("field.required", locale);
    }
    return errorMessage;
  };

  const hasErrors =
    !isNil(errors) && !isNil(errors[field]) && !isEmpty(errors[field]);

  const validationPattern = regex
    ? { required, pattern: new RegExp(regex) }
    : { required };

  return (
    <div className="field-creator__field-container">
      <div className="field-creator__labelfield">
        {getBlackAsterisk(required)}
        {label}
      </div>
      <input
        ref={register(validationPattern)}
        name={field}
        className={`field-creator__textfield${hasErrors ? "--error" : ""}`}
        type="text"
      />
      {errors[field] && isSubmitted && (
        <div className="forms__error-message">{getErrorMessage()}</div>
      )}
    </div>
  );
};

TextField.propTypes = {
  register: PropTypes.any,
  errors: PropTypes.any,
  locale: PropTypes.string,
  field: PropTypes.string,
  regex: PropTypes.string,
  required: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  label: PropTypes.string,
};

export default TextField;
